<template>
  <svg
    width="206"
    height="184"
    viewBox="0 0 206 184"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M119.404 48.0431C110.433 51.1654 112.748 61.7652 119.669 61.7652C123.663 61.7652 128.72 59.532 127.337 54.2668C131.946 57.917 133.25 53.9404 133.566 52.0302C135.634 56.9515 143.004 58.1324 147.453 52.0962C147.773 60.0391 159.661 61.3068 163.314 51.3043C165.852 56.83 171.41 54.6385 171.41 50.1929C173.951 58.6082 183.396 57.6566 186.729 50.8285C192.135 57.8129 200.304 49.8977 197.126 45.7682C203.008 48.4668 204.621 40.2842 195.875 41.2359C195.555 32.0253 186.615 34.5467 185.026 38.9888C183.754 28.6668 174.608 31.3654 174.928 35.4949C170.319 27.3957 160.909 23.7733 156.776 33.6194C150.098 21.7102 139.493 22.4292 138.641 34.13C128.15 24.4401 114.628 37.4016 119.397 48.0396L119.404 48.0431Z"
      fill="#717171"
    />
    <path
      d="M78.3203 67.8466C71.2464 69.1351 72.9602 77.3871 79.0955 71.6809C82.6481 74.4871 89.0893 75.9909 91.6964 70.7778C94.0427 74.4003 101.026 74.7615 101.012 69.4095C107.996 71.7191 109.894 63.2621 101.548 62.828C99.8791 57.4933 91.2062 57.6253 89.7428 63.3837C84.5669 58.1532 75.6924 64.113 78.3203 67.8466Z"
      fill="#717171"
    />
    <path
      d="M102.292 65.728C91.6964 65.8079 92.0927 78.2207 102.448 71.4864C106.89 76.4598 115.859 80.2628 120.962 73.3583C123.447 79.207 133.496 81.4958 134.828 73.73C144.38 78.8458 149.275 67.0512 137.272 64.311C136.201 56.1458 123.583 54.1488 119.999 62.1368C113.811 53.2388 99.4238 59.6466 102.295 65.728H102.292Z"
      fill="#F8F8F8"
    />
    <path
      d="M65.1285 18.9839C45.0019 20.0675 46.8477 43.6392 65.9315 29.9137C74.8233 38.9784 92.2108 45.4209 101.301 31.8412C106.539 42.7397 125.849 46.2093 127.698 31.3272C146.309 40.2044 154.576 17.3446 131.512 13.2047C128.752 -2.23312 104.589 -4.91086 98.4782 10.5895C85.9191 -5.77566 59.1322 7.67208 65.125 18.9839H65.1285Z"
      fill="#717171"
    />
    <path
      d="M52.0272 45.9766C41.9013 50.1408 45.2453 62.1993 53.2125 61.7548C57.8079 61.5013 63.4879 58.6012 61.5552 52.631C67.0926 56.5417 76.3877 51.926 75.755 47.5603C79.3215 53.8119 86.1799 56.9828 90.9178 49.7519C91.7903 58.8721 113.092 59.1535 116.662 47.4041C123.562 56.0034 134.984 50.2346 134.699 45.1188C138.165 54.6419 152.737 52.7318 156.143 44.6569C162.811 52.3532 175.543 43.7643 171.622 39.218C178.561 41.9444 180.869 27.3366 170.868 28.9898C169.912 18.4074 157.197 20.7656 155.657 25.9891C153.533 14.1876 138.158 18.1608 138.784 22.8946C132.961 13.868 113.113 10.7874 108.987 22.384C100.54 9.10299 76.0262 15.0767 75.8002 28.5939C63.1055 18.1156 45.864 34.0362 52.0341 45.9766H52.0272Z"
      fill="#F8F8F8"
    />
    <path
      d="M167.649 11.1625C159.543 11.3431 159.984 20.842 167.834 15.5664C171.292 19.3242 178.203 22.1374 182.026 16.7924C183.994 21.2414 191.711 22.8807 192.646 16.9209C200.012 20.7274 203.627 11.6418 194.408 9.683C193.498 3.44535 183.817 2.0596 181.164 8.21388C176.326 1.47265 165.386 6.53986 167.649 11.166V11.1625Z"
      fill="#717171"
    />
    <path
      d="M140.066 8.98838C138.064 12.8609 146.765 15.3267 149.313 11.7738C151.426 16.0005 158.125 14.4168 158.379 8.82514C165.247 11.8814 166.474 4.38656 158.08 6.4183C158.837 0.819707 147.484 -3.56679 144.759 4.14691C141.248 -0.889045 138.926 3.29601 139.309 5.50836C132.044 4.90404 131.286 10.9541 140.066 8.98838Z"
      fill="#717171"
    />
    <path
      d="M175.668 42.7675C179.044 38.0511 188.314 41.2775 186.375 45.0736C184.439 48.8662 172.387 47.3554 175.668 42.7675Z"
      fill="#F8F8F8"
    />
    <path
      d="M74.3193 55.274C75.5812 53.5097 79.0468 54.7149 78.3238 56.1354C77.6008 57.5559 73.0958 56.9897 74.3193 55.274Z"
      fill="#F8F8F8"
    />
    <path
      d="M42.5757 43.2086C44.3276 40.7635 49.1281 42.441 48.127 44.4033C47.1224 46.3691 40.8793 45.5876 42.5757 43.2086Z"
      fill="#F8F8F8"
    />
    <path
      d="M134.737 14.5453C136.489 12.1037 141.29 13.7743 140.285 15.74C139.281 17.7058 133.038 16.9244 134.737 14.5453Z"
      fill="#F8F8F8"
    />
    <path
      d="M157.576 51.1689C159.328 48.7238 164.128 50.3979 163.127 52.3636C162.126 54.3294 155.883 53.5479 157.576 51.1689Z"
      fill="#F8F8F8"
    />
    <path
      d="M68.709 20.578C70.4609 18.133 75.2614 19.807 74.2603 21.7728C73.2557 23.7385 67.0126 22.9571 68.709 20.578Z"
      fill="#F8F8F8"
    />
    <path
      d="M91.613 58.629C93.3615 56.184 98.1655 57.858 97.1609 59.8203C96.1598 61.7861 89.9132 61.0046 91.613 58.629Z"
      fill="#F8F8F8"
    />
    <path
      d="M140.758 60.1537C142.399 57.858 146.914 59.4278 145.976 61.2755C145.03 63.1232 139.163 62.3869 140.758 60.1537Z"
      fill="#F8F8F8"
    />
    <path
      d="M137.289 78.3248C138.453 76.6925 141.655 77.8108 140.987 79.1202C140.32 80.4295 136.159 79.9086 137.289 78.3248Z"
      fill="#F8F8F8"
    />
    <path
      d="M104.603 10.3915C107.471 6.38009 115.348 9.1273 113.704 12.3503C112.059 15.5768 101.815 14.2883 104.603 10.3915Z"
      fill="#F8F8F8"
    />
    <path
      d="M12.6359 110.614C2.51353 114.782 5.85754 126.837 13.8213 126.392C18.4167 126.139 24.0966 123.239 22.1639 117.268C27.7014 121.176 36.9965 116.563 36.3638 112.198C39.9303 118.449 46.7921 121.62 51.5266 114.389C52.4025 123.51 73.7006 123.791 77.2706 112.041C84.1706 120.641 95.5931 114.872 95.308 109.756C98.7737 119.279 113.346 117.369 116.749 109.294C123.416 116.991 136.149 108.402 132.224 103.852C145.767 106.047 147.856 90.6716 131.47 93.6272C130.517 83.0447 117.802 85.403 116.255 90.623C114.131 78.8215 98.7563 82.7947 99.3855 87.5285C93.563 78.4985 73.711 75.4213 69.5884 87.0179C61.1414 73.7334 36.628 79.7106 36.402 93.2278C23.7073 82.7495 6.46586 98.6701 12.6325 110.607L12.6359 110.614Z"
      fill="#BFCDD6"
    />
    <path
      d="M130.709 112.382C133.639 108.287 141.683 111.09 140 114.379C138.321 117.671 127.862 116.362 130.709 112.382Z"
      fill="#717171"
    />
    <path
      d="M133.357 87.6084C135.238 84.9792 140.403 86.7818 139.322 88.8934C138.245 91.0085 131.529 90.1645 133.357 87.6084Z"
      fill="#717171"
    />
    <path
      d="M27.9099 82.7461C30.4336 79.2174 37.3684 81.6347 35.9189 84.4687C34.4728 87.3062 25.4593 86.1775 27.9099 82.7461Z"
      fill="#717171"
    />
    <path
      d="M31.6711 124.048C33.4196 121.603 38.2236 123.277 37.219 125.243C36.2179 127.208 29.9713 126.427 31.6711 124.048Z"
      fill="#717171"
    />
    <path
      d="M28.7442 95.7319C32.2238 90.8661 41.7831 94.2003 39.7878 98.1109C37.7925 102.022 25.3655 100.462 28.7442 95.7319Z"
      fill="#F8F8F8"
    />
    <path
      d="M9.63607 108.898C11.6244 106.113 17.0993 108.023 15.9556 110.26C14.812 112.5 7.6964 111.607 9.63607 108.898Z"
      fill="#929292"
    />
    <path
      d="M66.6964 99.8718C68.6882 97.0864 74.1596 98.9931 73.0159 101.233C71.8723 103.473 64.7567 102.581 66.6964 99.8718Z"
      fill="#F8F8F8"
    />
    <path
      d="M34.6605 132.946C36.6523 130.16 42.1237 132.071 40.98 134.307C39.8364 136.544 32.7208 135.651 34.6605 132.946Z"
      fill="#F8F8F8"
    />
    <path
      d="M64.1935 58.761C66.1749 55.993 71.6115 57.8858 70.4783 60.112C69.3381 62.3383 62.2712 61.4492 64.1935 58.761Z"
      fill="#F8F8F8"
    />
    <path
      d="M19.3206 113.524C1.78711 118.182 8.41952 133.835 27.4964 123.985C29.6168 130.338 40.0312 129.969 45.6486 123.798C48.6658 130.897 60.568 133.064 66.4322 123.235C84.6886 131.491 89.1972 111.781 69.3973 111.809C67.1065 98.4965 45.148 99.4793 40.7994 109.169C33.291 98.3714 15.834 106.148 19.3171 113.524H19.3206Z"
      fill="#F8F8F8"
    />
    <path
      d="M60.9121 65.8218H54.1581H53.6784H46.9243L40.4136 161.96H53.6784H54.1581H67.4229L60.9121 65.8218Z"
      fill="#444ABF"
    />
    <path
      d="M54.1581 131.119H65.3337L65.0278 126.542H54.1581H53.6784H42.8155L42.5027 131.119H53.6784H54.1581Z"
      fill="#716495"
    />
    <path
      d="M54.1581 77.8699H53.6784H46.1074L45.8015 82.4474H53.6784H54.1581H62.0384L61.729 77.8699H54.1581Z"
      fill="#716495"
    />
    <path
      d="M54.1581 102.206H53.6784H44.4598L44.1504 106.783H53.6784H54.1581H63.6861L63.3767 102.206H54.1581Z"
      fill="#716495"
    />
    <path d="M58.1416 135.697H49.7017V160.032H58.1416V135.697Z" fill="#91B0CD" />
    <path
      d="M54.0782 64.2797H53.7619H45.2871L45.0229 68.1453H53.7619H54.0782H62.8171L62.5529 64.2797H54.0782Z"
      fill="#91B0CD"
    />
    <path
      d="M124.33 65.8218H117.576H117.096H110.342L103.832 161.96H117.096H117.576H130.844L124.33 65.8218Z"
      fill="#444ABF"
    />
    <path
      d="M117.576 131.119H128.755L128.446 126.542H117.576H117.096H106.234L105.921 131.119H117.096H117.576Z"
      fill="#716495"
    />
    <path
      d="M117.576 77.8699H117.096H109.525L109.219 82.4474H117.096H117.576H125.456L125.147 77.8699H117.576Z"
      fill="#716495"
    />
    <path
      d="M117.576 102.206H117.096H107.881L107.568 106.783H117.096H117.576H127.108L126.795 102.206H117.576Z"
      fill="#716495"
    />
    <path d="M121.56 135.697H113.12V160.032H121.56V135.697Z" fill="#91B0CD" />
    <path
      d="M117.496 64.2797H117.18H108.702L108.441 68.1453H117.18H117.496H126.232L125.971 64.2797H117.496Z"
      fill="#91B0CD"
    />
    <path d="M79.8082 78.5124H72.8977V156.889H79.8082V78.5124Z" fill="#473E60" />
    <path d="M81.7826 75.6019H70.9302V79.7662H81.7826V75.6019Z" fill="#533B6B" />
    <path d="M181.192 104.679H174.281V183.055H181.192V104.679Z" fill="#533B6B" />
    <path d="M183.163 101.768H172.311V105.932H183.163V101.768Z" fill="#473E60" />
    <path d="M98.6312 78.5124H91.7207V156.889H98.6312V78.5124Z" fill="#473E60" />
    <path d="M100.599 75.6019H89.7498V79.7662H100.599V75.6019Z" fill="#533B6B" />
    <path d="M136.521 145.907H30.9585V171.108H136.521V145.907Z" fill="#716495" />
    <path
      d="M13.9604 131.675H13.4772H3.75802L0.212402 184H13.4772H13.9604H27.2217L23.6796 131.675H13.9604Z"
      fill="#473E60"
    />
    <path
      d="M13.9187 129H13.5155H2.68047L2.37109 133.581H13.5155H13.9187H25.0631L24.7537 129H13.9187Z"
      fill="#533B6B"
    />
    <path d="M144.808 114.018V130.928H173.778L144.808 114.018Z" fill="#533B6B" />
    <path d="M190.842 130.921H141.971V184H190.842V130.921Z" fill="#716495" />
    <path d="M190.842 170.167H141.971V184H190.842V170.167Z" fill="#473E60" />
    <path d="M193.223 127.108H139.583V132.765H193.223V127.108Z" fill="#473E60" />
    <path d="M151.885 136.329H145.027V143.778H151.885V136.329Z" fill="white" />
    <path d="M151.399 136.857H145.51V143.254H151.399V136.857Z" fill="#533B6B" />
    <path d="M163.986 136.329H157.127V143.778H163.986V136.329Z" fill="white" />
    <path d="M163.499 136.857H157.614V143.254H163.499V136.857Z" fill="#533B6B" />
    <path d="M176.089 136.329H169.231V143.778H176.089V136.329Z" fill="white" />
    <path d="M175.606 136.857H169.718V143.254H175.606V136.857Z" fill="#533B6B" />
    <path d="M188.193 136.329H181.335V143.778H188.193V136.329Z" fill="white" />
    <path d="M187.706 136.857H181.818V143.254H187.706V136.857Z" fill="#533B6B" />
    <path d="M166.057 156.622H11.9998V184H166.057V156.622Z" fill="#9580A9" />
    <path d="M166.057 177.606H11.9998V184H166.057V177.606Z" fill="#6B567F" />
    <path d="M58.1172 164.648H48.8743V184H58.1172V164.648Z" fill="#533B6B" />
    <path d="M90.3025 164.648H81.063V184H90.3025V164.648Z" fill="#533B6B" />
    <path d="M122.491 164.648H113.248V184H122.491V164.648Z" fill="#533B6B" />
    <path
      d="M177.681 101.327C176.152 100.869 176.972 96.614 179.558 97.7636C180.917 93.5925 182.43 95.5652 182.43 95.5652C182.43 95.5652 178.644 92.4915 181.529 91.4218C178.696 88.4697 183.333 82.6349 185.947 86.042C188.283 80.5511 193.268 85.5558 193.195 87.3166C196.935 82.173 200.641 87.393 198.663 91.0988C203.213 89.6054 207.798 95.2005 203.755 97.7324C208.236 97.9963 204.103 102.636 200.898 99.9482C196.838 103.63 193.157 101.508 193.487 97.3469C190.946 100.014 187.804 98.8472 186.653 96.6106C186.942 99.3612 185.325 99.3369 183.688 98.3158C184.456 102.282 181.63 100.462 180.584 99.8405C179.218 99.4897 178.96 101.723 177.685 101.337L177.681 101.327Z"
      fill="#F8F8F8"
    />
    <path
      d="M178.901 93.0993C178.818 91.2586 175.502 90.3695 175.606 93.0993C175.71 95.8291 179.044 96.3015 178.901 93.0993Z"
      fill="#F8F8F8"
    />
    <path
      d="M187.435 101.473C188.182 100.087 189.973 100.108 190.365 101.473C190.755 102.841 186.072 104.008 187.435 101.473Z"
      fill="#F8F8F8"
    />
    <path
      d="M202.351 87.1777C203.098 85.7919 204.892 85.8128 205.278 87.1777C205.667 88.5461 200.985 89.713 202.351 87.1777Z"
      fill="#F8F8F8"
    />
  </svg>
</template>
